import modalTemplate from './manage.revoke-shared.modal.html';

export default function ManageSharedAssetsController(
  $uibModal,
  $filter,
  transfersService,
  equipmentRepository,
  arrayUtil,
  gettextCatalog,
  $state,
) {
  'ngInject';

  let vm = this;
  let options = {
    limit: 2500,
    since: 0,
  };
  let queryString = '';
  //public
  vm.loading = true;
  vm.errorText = '';
  vm.errorFlag = false;
  vm.revokeFlag = false;
  vm.accounts = [];
  vm.sharedAssets = [];
  vm.selectedEquipment = [];
  vm.revokedEquipment = [];
  vm.searchString = '';
  vm.isEquipmentSelected = true;
  vm.shareKey = null;

  //paging
  vm.itemsPerPage = 15;
  vm.currentPage = {
    responseData: null,
  };
  vm.maxSize = 1;

  vm.searchBarResults = searchBarResults;
  vm.openConfirmModal = openConfirmModal;
  vm.manageCheckedList = manageCheckedList;
  vm.updateEquipmentList = updateEquipmentList;
  vm.resetFlags = resetFlags;
  vm.shareAssetsPath = shareAssetsPath;

  vm.$onInit = function () {
    vm.currentPage.responseData = 1;
    getShareKeys();
  };

  function shareAssetsPath() {
    $state.go('admin.share');
  }

  function getShareKeys() {
    transfersService
      .getTransferKeysToShare()
      .then(function (response) {
        //vm.keys = response.data; // for "View Assets Shared To:" option selection
        let shareKeys = response.data || [];
        vm.accounts = buildAccountDropdown(shareKeys);
      })
      .catch(function () {
        vm.errorText = gettextCatalog.getString(
          'An error occurred while trying to retrieve transfer keys.',
        );
        vm.errorFlag = true;
      })
      .finally(function () {
        vm.loading = false;
      });
  }

  // back to page one to display result properly
  function searchBarResults() {
    vm.currentPage.responseData = 1;
    vm.updateEquipmentList(vm.shareKey, 'shareFiltered');
  }

  function openConfirmModal() {
    resetFlags();
    if (vm.selectedEquipment.length <= 0) {
      vm.isEquipmentSelected = false;
      return;
    }
    let modalInstance = $uibModal.open({
      animation: true,
      template: modalTemplate,
      controller: 'ManageSharedAssetsModalController',
      backdropClass: 'tr-share-revoke-dismiss',
      size: 'md',
    });
    modalInstance.result
      .then(function () {
        revokeShare();
      })
      .catch(() => {});
  }

  function revokeShare() {
    if (vm.selectedEquipment.length <= 0) {
      return;
    }
    if (!vm.shareKey) {
      vm.errorText = gettextCatalog.getString('Missing share key.');
      vm.errorFlag = true;
      return;
    }
    let shareObj = getShareObject();
    transfersService
      .postEquipmentToShare(vm.shareKey, shareObj)
      .then(function () {
        vm.revokeFlag = true;
        vm.revokedEquipment = vm.selectedEquipment.splice(0);
        vm.updateEquipmentList(vm.shareKey, 'shareRevoked');
      })
      .catch(function () {
        vm.errorText = gettextCatalog.getString(
          'An error occurred while trying to revoke the share.',
        );
        vm.errorFlag = true;
      });
  }

  function getShareObject() {
    let shareObj = {
      action: 'revoke',
      resources: [],
    };
    vm.selectedEquipment.forEach((selected) => {
      shareObj.resources.push(transfersService.getResourceUrl() + selected.id);
    });
    return shareObj;
  }

  function manageCheckedList(equip) {
    equip.checked = !equip.checked;
    if (equip.checked) {
      vm.selectedEquipment.push(equip);
      resetFlags();
    } else {
      // un-checked
      vm.selectedEquipment = vm.selectedEquipment.filter((asset) => asset.id !== equip.id);
    }
    GTM_ListChanged(equip.checked ? 'shareAssetSelected' : 'shareAssetDeselected');
  }

  function updateEquipmentList(key, GTMEvent) {
    vm.shareKey = key;
    vm.selectedEquipment = [];
    queryString = vm.searchString && vm.searchString.length > 0 ? vm.searchString : '*';
    equipmentRepository
      .getEquipmentSearch(queryString, options, null, null, vm.shareKey)
      .then(function (response) {
        let equipResponse = response.data.hits;
        vm.sharedAssets = vm.revokeFlag
          ? arrayUtil.removeItems(equipResponse, vm.revokedEquipment)
          : persistSelected(equipResponse);
        GTM_ListChanged(GTMEvent);
      })
      .catch(function () {
        vm.errorText = gettextCatalog.getString(
          'An error occurred while trying to retrieve asset information.',
        );
        vm.errorFlag = true;
      });
  }

  function persistSelected(equipResponse) {
    if (vm.selectedEquipment.length > 0) {
      vm.selectedEquipment.forEach((selectedEquip) => {
        equipResponse.forEach((equip) => {
          if (selectedEquip.id === equip.id) {
            equipResponse.checked = true;
          }
        });
      });
    }
    return equipResponse;
  }

  function resetFlags() {
    vm.revokeFlag = false;
    vm.errorFlag = false;
    vm.isEquipmentSelected = true;
  }

  function buildAccountDropdown(shareKeys = []) {
    let accountArray = [];
    shareKeys.forEach(function (shareKey) {
      if (shareKey.attrs && shareKey.attrs.name) {
        accountArray.push({
          key: shareKey.key,
          name: shareKey.account + ' - ' + shareKey.attrs.name,
        });
      } else {
        accountArray.push({
          key: shareKey.key,
          name: shareKey.account,
        });
      }
    });
    let accounts = $filter('orderBy')(accountArray, 'name', false); // sort the acccount in dropdown by account name
    vm.accountMessage =
      accounts.length === 0
        ? gettextCatalog.getString('No accounts available to share to')
        : gettextCatalog.getString('Select Account...');

    return accounts;
  }

  vm.pageChanged = function () {
    GTM_ListChanged('sharePageChanged');
  };

  function GTM_ListChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: vm.sharedAssets.length,
        totalSelected: vm.selectedEquipment.length,
        pageNumber: vm.currentPage.responseData,
      },
    });
  }
}
